import type { TUserMenuResponse } from 'src/types/menu';

import { useQuery } from '@tanstack/react-query';
import { UserMenusResponse } from 'src/schema/menu-schema';

import { instance } from './instance';

const getDashboardMenus = async (): Promise<TUserMenuResponse> => {
  const { data } = await instance.get(
    `/api/panel/authsystem/v1.0/menu/user-accesses`,
  );
  const result = UserMenusResponse.safeParse(data);
  if (!result.success) {
    throw new Error(`Parse User Menu Response Error${result.error.toString()}`);
  }
  return data;
};

//
function useGetDashboardMenus({ enabled = true }: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['dashboard-menus'],
    queryFn: () => getDashboardMenus(),
    enabled,
  });
}

export { useGetDashboardMenus };
